import { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dropdown, Tag, Image, Card, message } from "antd";
import {
    CopyOutlined,
    DownloadOutlined,
    PinterestOutlined,
} from "@ant-design/icons";
import { PinterestShareButton } from "react-share";
import { PBox, PText } from "../theme/BaseTheme";
import { refetchUser } from "../../actions/auth";
import InteriorDesignDownloadModal from "./InteriorDesignDownloadModal";

export const InteriorDesignCard = (props) => {
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const showDownloadModal = () => {
        setIsDownloadModalOpen(true);
    };
    const handleDownloadModalOk = () => {
        setIsDownloadModalOpen(false);
    };
    const handleDownloadModalCancel = () => {
        setIsDownloadModalOpen(false);
    };

    return (
        <PBox css={styles}>
            <PBox className="pattern-card">
                <Card
                    loading={isProcessing}
                    hoverable={true}
                    cover={
                        <Image
                            src={props.image_url}
                            crossOrigin={
                                process.env.NODE_ENV === "development"
                                    ? "anonymous"
                                    : ""
                            }
                        />
                    }
                    actions={[
                        <DownloadOutlined
                            key="download"
                            onClick={showDownloadModal}
                        />,
                        <CopyOutlined
                            key="copy"
                            onClick={async () => {
                                await navigator.clipboard.writeText(
                                    props.prompt
                                );
                                await message.success(
                                    "Prompt copied to clipboard."
                                );
                            }}
                        />,
                        <PinterestShareButton
                            url={String(window.location.origin)}
                            media={props.image_url}
                            description={props.prompt}
                        >
                            <PinterestOutlined />
                        </PinterestShareButton>,
                    ]}
                >
                    <Card.Meta description={`Prompt: ${props.prompt}`} />
                </Card>
                {isDownloadModalOpen && (
                    <InteriorDesignDownloadModal
                        interiorDesignUUID={props.interior_design_uuid}
                        isDownloadModalOpen={isDownloadModalOpen}
                        handleDownloadModalOk={handleDownloadModalOk}
                        handleDownloadModalCancel={handleDownloadModalCancel}
                    />
                )}
            </PBox>
        </PBox>
    );
};

const styles = {
    "& .pattern-card": {
        position: "relative",
    },
    "& .ant-card-meta-description": { color: "#1b1b1b" },
    "& .ant-image-img": { padding: "0.5rem" },
    "& .ant-image-mask": { margin: "0.5rem" },
};

function mapStateToProps(state) {
    return { userAccount: state.authReducer?.userAuth?.userAccount };
}

export default connect(mapStateToProps, { refetchUser })(
    withRouter(InteriorDesignCard)
);
